import React from 'react';
import classNames from 'classnames';

export default function Flag({ code, size = 'large' }) {
	const getSizeClassname = () => {
		switch (size) {
		case 'large':
			return 'w-6 h-6';
		default:
			return 'h-4 w-4';
		}
	};

	return (
		<img
			alt={`${code} flag}`}
			className={classNames(getSizeClassname(), 'mr-2')}
			src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${code}.svg`}
		/>

	);
}
